import { converter } from "../utilities/converter";

export const converterMixin = {
  methods:{
    milimetersToInch(value, rounded = true){
      if(rounded) return Number(converter.metricToImperial["mm"](Number(value)).toFixed(3));
      return Number(converter.metricToImperial["mm"](Number(value)));
    },
    gramsToLb(value, rounded = true){
      if(rounded) return Number(converter.metricToImperial["g"](Number(value)).toFixed(3));
      return Number(converter.metricToImperial["g"](Number(value)));
    },
    mm2ToIn2(value, rounded = true){
      if(rounded) return Number(converter.metricToImperial["mm2"](Number(value)).toFixed(3));
      return Number(converter.metricToImperial["mm2"](Number(value)));
    },
    kgM3TolbInch3(value, rounded = true){
      if(rounded) return Number(converter.metricToImperial["kg/m3"](Number(value)).toFixed(3));
      return Number(converter.metricToImperial["kg/m3"](Number(value)));
    },
    inchToMilimeters(value, rounded = true){
      if(rounded) return Number(converter.imperialToMetric["inch"](Number(value)).toFixed(3));
      return Number(converter.imperialToMetric["inch"](Number(value)));
    },
    lbToGrams(value, rounded = true){
      if(rounded) return Number(converter.imperialToMetric["lb"](Number(value)).toFixed());
      return Number(converter.imperialToMetric["lb"](Number(value)));
    },
    in2ToMm2(value, rounded = true){
      if(rounded) return Number(converter.imperialToMetric["in2"](Number(value)).toFixed(3));
      return Number(converter.imperialToMetric["in2"](Number(value)));
    },
    lbInch3ToKgM3(value, rounded = true){
      if(rounded) return Number(converter.imperialToMetric["lb/inch3"](Number(value)).toFixed(3));
      return Number(converter.imperialToMetric["lb/inch3"](Number(value)));
    },
    convertItemAttributeToImperialByBundle(attribute, bundle){
      const attributeId = attribute.id;
      if(!attributeId) return attribute;
      if(!bundle.displayData || !bundle.displayData.main_attributes ) return attribute;
      const foundDisplayDataAttribute = bundle.displayData.main_attributes.find(el => el.attribute_id && el.attribute_id === attributeId);
      if(!foundDisplayDataAttribute) return attribute;
      if(foundDisplayDataAttribute.convert === undefined || foundDisplayDataAttribute.convert === null) return attribute;
      switch(foundDisplayDataAttribute.convert){
        case 'in2mm': {
          attribute.pivot.override = this.milimetersToInch(attribute.pivot.override, false).toFixed(2);
          break;
        }
        case 'lb2g': {
          attribute.pivot.override = this.gramsToLb(attribute.pivot.override,false).toFixed(2);
          break;
        }
        default: throw new Error('Unsupported convert type!');
      }
      return attribute;
    },

    convertItemAttributeToMetricByBundle(attribute, bundle){
      const attributeId = attribute.id;
      if(!attributeId) return attribute;
      if(!bundle.displayData || !bundle.displayData.main_attributes ) return attribute;
      const foundDisplayDataAttribute = bundle.displayData.main_attributes.find(el => el.attribute_id && el.attribute_id === attributeId);
      if(!foundDisplayDataAttribute) return attribute;
      if(foundDisplayDataAttribute.convert === undefined || foundDisplayDataAttribute.convert === null) return attribute;
      switch(foundDisplayDataAttribute.convert){
        case 'in2mm': {
          attribute.pivot.override = this.inchToMilimeters(attribute.pivot.override, false).toFixed(2);
          break;
        }
        case 'lb2g': {
          attribute.pivot.override = this.lbToGrams(attribute.pivot.override,false).toFixed(2);
          break;
        }
        default: throw new Error('Unsupported convert type!');
      }
      return attribute;
    }

  },
  computed:{
   
    isMetricUnitSystem(){
      return this.$store.getters.isMetricUnitSystem; 
    },

    imperialLabel(){
      return (type) => {
        return converter.metricToImperial.labels[type];
      }
    },
    metricLabel(){
      return (type) => {
        return converter.imperialToMetric.labels[type];
      }
    },
  }
};
